import PropTypes from 'prop-types';
import React from 'react';
import { text as textConfig } from './config';
import { StyledPromoIdentifier, StyledPromoIdentifierText } from './styled-promo-identifier';

const { forwardRef } = React;

const propTypes = {
	text: PropTypes.string.isRequired,
	color: PropTypes.oneOf(['brand', 'black', 'featured']),
	className: PropTypes.string,
	dataTestId: PropTypes.string,
	size: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

const defaultProps = {
	color: 'black',
	className: undefined,
	dataTestId: undefined,
	size: 'l',
};

const PromoIdentifier = forwardRef(({ text, color, className, dataTestId, size, ...rest }, ref) => (
	<StyledPromoIdentifier
		backgroundColor={color}
		className={className}
		data-testid={dataTestId || 'fuse-promo-identifier-test-id'}
		ref={ref}
		{...rest}
	>
		<StyledPromoIdentifierText
			size={textConfig.size[size] || { xxs: 'm2', m: 'm1', l: '1' }}
			textColor={color}
			type="paragraph"
		>
			{text}
		</StyledPromoIdentifierText>
	</StyledPromoIdentifier>
));

PromoIdentifier.propTypes = propTypes;
PromoIdentifier.defaultProps = defaultProps;

export default PromoIdentifier;
export { PromoIdentifier };
